import {browserHistory} from 'react-router';

/**
 * Takes an object of query params and merges it with the existing query params.
 * Values which are undefined or null will unset the param
 * @param params
 * @param shouldReplace - `browserHistory.push` vs `browserHistory.replace`
 */
export function set(params, shouldReplace = false) {
  // TODO could be using more of react-router - router location has most of this stuff,
  // and browserHistory can take a second param for it

  const currentParams = new URLSearchParams(location.search);

  for (const [key, val] of Object.entries(params)) {
    if (val == null) {
      currentParams.delete(key);
    } else {
      currentParams.set(key, val as string);
    }
  }

  const query = '?' + currentParams.toString();

  if (shouldReplace) {
    browserHistory.replace(location.pathname + query);
  } else {
    browserHistory.push(location.pathname + query);
  }
}

export function unset(fields) {
  const currentParams = new URLSearchParams(location.search);

  for (const field of fields) {
    currentParams.delete(field);
  }

  const query = '?' + currentParams.toString();
  browserHistory.push(location.pathname + query);
}
